var styles = {"linkBlockContainer":"Link-module_linkBlockContainer__IRxmF","linkBlockContainer_link":"Link-module_linkBlockContainer_link__JRXc0"};

export { styles as default };
//# sourceMappingURL=Link.module.scss.js.map
